import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AuthModal } from "./AuthModal";
import theme from "../theme";
import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/system";

const queryClient = new QueryClient();

const SpiAuth = ({ description }) => {
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    setPageLoaded(true);
  }, []);

  if (!pageLoaded || typeof window === "undefined") return null;

  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthModal description={description} />
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default SpiAuth;

SpiAuth.propTypes = {
  description: PropTypes.string,
};
